import classNames from 'classnames';
import { toId } from '../../utils';
import { LayoutStack } from '../layouts';
import styles from './Heading.module.css';
import LevelMap from './LevelMap';
import { type HeadingProps } from './types';
function Heading({
  as,
  level,
  children,
  subtitle,
  className,
  flex,
  ['aria-describedby']: ariaDescribedBy,
  ...props
}: HeadingProps) {
  const Tag = as || LevelMap[level];
  const subtitleId = subtitle ? toId(subtitle) : ariaDescribedBy;
  return <LayoutStack space="50">
      <Tag {...props} className={classNames(styles[level], className, {
      [styles.flex!]: flex
    })} aria-describedby={subtitle ? subtitleId : ariaDescribedBy}>
        {children}
      </Tag>
      {subtitle ? <div id={subtitleId} aria-hidden={true}>
          {subtitle}
        </div> : null}
    </LayoutStack>;
}
export default Heading;